
import React, { PureComponent } from 'react';
import {Checkbox, Col, Row} from 'antd';
import {RTLCol} from "../RTLKit";


export default class CheckBoxField extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
        };
    }


    onChangeVal(val){
        const {input} =  this.props;
        input.onChange(val);
    }



    render() {

        const {
            input,
            label,
            checked,
            defaultValue,
            meta: { touched, error, warning },
        } = this.props;

        let value = null
        if(input.value)
            value = input.value

        return (
            <div>
                <RTLCol span={24}>
                    <RTLCol className="formLabel" md={label ? 5 : 0} sm={24}>
                        {label ? <label>{label} {label != ' ' ? ':' : null} </label> : null}
                    </RTLCol>
                    <RTLCol md={label ? 15 : 19} sm={24} style={{marginBottom : 20}}>
                        <Checkbox.Group style={{ width: '100%',paddingTop:10,textAlign:'right' }} onChange={this.onChangeVal.bind(this)} >
                            <Row>
                                {this.props.list.map((item,index)=>{
                                    return (
                                        <RTLCol span={8} key={index}>
                                            <Checkbox value={item.value}>{item.label}</Checkbox>
                                        </RTLCol>)}
                                )}
                            </Row>
                        </Checkbox.Group>
                    </RTLCol>
                    <RTLCol md={3} sm={24}>
                        {touched &&
                        ((error && <span className="errorMsg">{error}</span>) ||
                            (warning && <span className="warningMsg">{warning}</span>))}
                    </RTLCol>
                </RTLCol>
            </div>
        );
    }
}


